import React from "react";
import { MARQUEE_ITEMS } from "../mock/data";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="border-y border-white/[0.07] bg-[#0b0f0a] py-4 overflow-hidden">
      <div className="marquee-track">
        {items.map((it, i) => (
          <div key={i} className="flex items-center shrink-0">
            <span className="label text-[var(--muted)] px-6">{it}</span>
            <span className="w-1 h-1 rounded-full bg-accent" />
          </div>
        ))}
      </div>
    </div>
  );
}
